import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToaster } from 'context/Toaster/ToasterContext';
import useApi from 'hooks/useApi';
import { VARIANT_COLOR_ENUM } from 'types/utils';
import cardsFactory from 'utils/factories/card';

const useUserList = (name: string) => {
  const apiClient = useApi();
  const { addToaster } = useToaster();
  const queryClient = useQueryClient();

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: cardsFactory.statsList() });
    queryClient.invalidateQueries({ queryKey: cardsFactory.statsDetails() });
  };

  const addToWantlist = useMutation({
    mutationFn: (reference: string) =>
      apiClient.cardUserListCards.apiCardUserListCardsPost({ name, cards: [reference] }),
    onSuccess: () => {
      addToaster({ message: 'added-in-wantlists', variant: VARIANT_COLOR_ENUM.SUCCESS });
      invalidate();
    },
  });

  const removeFromWantlist = useMutation({
    mutationFn: (reference: string) =>
      apiClient.cardUserLists.apiCardUserListsListNamecardsReferenceDelete(
        name,
        reference.split('/').pop() || reference,
      ),
    onSuccess: () => {
      addToaster({ message: 'removed-in-wantlists', variant: VARIANT_COLOR_ENUM.SUCCESS });
      invalidate();
      queryClient.invalidateQueries({ queryKey: cardsFactory.list() });
    },
  });

  const toggleCardWantlist = (id?: string, isInWantlist?: boolean) => {
    if (!id) {
      throw new Error('no card id given');
    }

    if (!isInWantlist) {
      addToWantlist.mutate(id);
    } else {
      removeFromWantlist.mutate(id);
    }
  };

  return { addToWantlist, removeFromWantlist, toggleCardWantlist };
};

export default useUserList;
